import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export function FleetNoSignalBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'border-status-warning-border bg-status-warning text-status-warning-foreground',
        className,
      )}
    >
      Kein Signal
    </Badge>
  );
}
